import React from 'react';
import { EyeIcon } from 'lucide-react';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
import type { EM } from './useEventManager';
export const VisibilitySection: React.FC<{
  em: EM;
}> = ({
  em
}) => {
  const dk = useDarkClasses();
  const {
    formData,
    updateNestedField
  } = em;
  const visibility = formData.visibility!;
  return <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-19366" data-mp="3dh88y8q5p68">
      <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-19367" data-mp="10zof6esi3tlr">
        <EyeIcon className="w-5 h-5 mr-2 text-purple-500" data-id="element-19368" data-mp="w023waw8gnfl" />
        Visibility Controls
      </h2>

      <div className="space-y-4" data-id="element-19369" data-mp="r8tu3dqzr01w">
        {[{
        id: 'showOnProfile',
        label: 'Show on Public Profile',
        desc: 'Event will appear on your author/vendor page'
      }, {
        id: 'showInSearch',
        label: 'Show in Global Event Search',
        desc: 'Readers can find this in the main Events Hub'
      }, {
        id: 'allowCalendar',
        label: 'Allow "Add to Calendar"',
        desc: 'Readers can save this to their personal calendars'
      }, {
        id: 'allowReminders',
        label: 'Allow "Get Reminder"',
        desc: 'Readers can opt-in to email notifications'
      }].map(toggle => <div key={toggle.id} className="flex items-start justify-between" data-id="element-19370" data-mp="1gpthwur15lr3">
            <div className="pr-4" data-id="element-19371" data-mp="12r3kfe0atk27">
              <label className={`text-sm font-medium ${dk.textPrimary}`} data-id="element-19372" data-mp="16tqhbtbttv69">
                {toggle.label}
              </label>
              <p className={`text-xs mt-0.5 ${dk.textFaint}`} data-id="element-19373" data-mp="sv8x45l4r0t3">{toggle.desc}</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer flex-shrink-0 mt-1" data-id="element-19374" data-mp="xsildhws96fc">
              <input type="checkbox" className="sr-only peer" checked={visibility[toggle.id as keyof typeof visibility]} onChange={e => updateNestedField('visibility', toggle.id, e.target.checked)} data-id="element-19375" data-mp="2n99uem117fr2" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600" data-id="element-19376" data-mp="2lq9wrzdha37h"></div>
            </label>
          </div>)}
      </div>
    </div>;
};